import { useState } from 'react';

const faqList = [
  {
    q: 'Что такое наставничество сотрудников?',
    a: 'Это процесс, в котором более опытный сотрудник или руководитель помогает менее опытному развивать профессиональные навыки и самостоятельность. Цель наставничества — не передать готовые ответы, а помочь сотруднику научиться самостоятельно решать рабочие задачи и брать ответственность за результат.',
  },
  {
    q: 'Чем наставничество отличается от обучения?',
    a: 'Обучение — это передача знаний и навыков, чаще в рамках тренинга или курса. Наставничество — это длительный процесс сопровождения в рабочей практике: постановка развивающих задач, наблюдение, обратная связь и постепенная передача ответственности. Они дополняют друг друга, но решают разные задачи.',
  },
  {
    q: 'Какие навыки нужны наставнику?',
    a: 'Умение объяснять, наблюдать и видеть причины ошибок, задавать вопросы вместо выдачи готовых ответов, давать обратную связь, ставить развивающие задачи, сохранять терпение, контролировать прогресс и постепенно передавать ответственность. Наставничество — это отдельная компетенция, которую нужно развивать.',
  },
  {
    q: 'Как руководителю развивать сотрудников?',
    a: 'Через развивающие задачи немного выше текущего уровня, делегирование, совместный разбор ситуаций, наблюдение, обратную связь и разбор ошибок. Развитие становится эффективнее, когда встроено в рабочий процесс, а не происходит только на обучении.',
  },
  {
    q: 'Как правильно передавать опыт сотрудникам?',
    a: 'Не просто показать свой способ работы, а выстроить последовательность: определить цель, показать стандарт, дать попробовать, наблюдать, дать обратную связь, повторить и постепенно увеличивать самостоятельность. Главное — не забирать задачу обратно при первой ошибке.',
  },
  {
    q: 'Как развивать самостоятельность сотрудников?',
    a: 'Постепенно уменьшать объём контроля и передавать ответственность. Сотрудник должен получать задачи, где он сам принимает решения и отвечает за результат. Если руководитель постоянно решает проблемы за сотрудника, команда не становится самостоятельнее.',
  },
  {
    q: 'Как наставничество связано с кадровым резервом?',
    a: 'Кадровый резерв — это не просто список перспективных сотрудников. Чтобы из специалиста вырос руководитель, нужны условия: сложные задачи, развитие ответственности, передача функций, возможность принимать решения и подготовка управленческих навыков. Наставничество создаёт эти условия.',
  },
  {
    q: 'Как подготовить сотрудников к руководящим должностям?',
    a: 'Через постепенную передачу управленческих функций: участие в принятии решений, взаимодействие с другими подразделениями, развитие коммуникации и обратной связи. Подготовка к руководящей роли — это системный процесс, а не разовое назначение.',
  },
  {
    q: 'Как обучить руководителей навыкам наставничества?',
    a: 'Через практическую программу: роль наставника, алгоритм передачи опыта, постановка развивающих задач, наблюдение, обратная связь, работа с ошибками и развитие самостоятельности. Содержание адаптируется под компанию и конкретные ситуации участников.',
  },
  {
    q: 'Можно ли разработать программу наставничества под конкретную компанию?',
    a: 'Да, адаптация — обязательный этап. Программа подстраивается под отрасль, структуру компании, уровень наставников и реальные ситуации развития сотрудников. Сначала проводится диагностика задач, затем настраивается содержание.',
  },
  {
    q: 'Можно ли обучать наставников онлайн?',
    a: 'Да, обучение проводится как очно в Минске и Беларуси, так и онлайн. Формат подбирается под задачу: тренинг для наставников, тренинг для руководителей, модульная программа, бизнес-игры, коучинг или сопровождение.',
  },
  {
    q: 'Что делать, если наставник постоянно делает работу за сотрудника?',
    a: 'Это типичная ошибка «проще сделать самому». Вместо исправления ошибки за сотрудника наставник должен наблюдать, задавать вопросы и давать обратную связь, чтобы сотрудник понял, что именно сделал неправильно. Иначе ситуация повторяется, а сотрудник остаётся зависимым.',
  },
  {
    q: 'Как оценивать эффективность наставничества?',
    a: 'Через изменения в работе сотрудника: выросла ли самостоятельность, снизилось ли количество повторяющихся ошибок, сократилось ли время выхода новых сотрудников на эффективность. Оцениваются изменения в поведении, а не обещаются гарантированные финансовые показатели.',
  },
  {
    q: 'Чем наставничество отличается от адаптации сотрудников?',
    a: 'Адаптация помогает новому сотруднику войти в компанию и освоиться в должности. Наставничество развивает профессиональные навыки и самостоятельность. Они могут работать вместе, но это разные процессы: адаптация — про вхождение, наставничество — про развитие.',
  },
];

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  return (
    <section id="faq" className="py-16 md:py-24 bg-gray-50">
      <div className="max-w-4xl mx-auto px-6">
        <h2 className="text-2xl md:text-4xl font-bold text-gray-900 text-center mb-4">
          Часто задаваемые вопросы
        </h2>
        <p className="text-base md:text-lg text-gray-600 text-center mb-14 max-w-3xl mx-auto leading-relaxed">
          Ответы на ключевые вопросы о наставничестве и развитии сотрудников
        </p>

        <div className="space-y-4">
          {faqList.map((item, i) => (
            <div key={i} className="bg-white rounded-xl border border-gray-200 overflow-hidden">
              <button
                onClick={() => setOpenIndex(openIndex === i ? null : i)}
                className="w-full flex items-center justify-between px-6 py-5 text-left hover:bg-gray-50 transition-colors cursor-pointer"
              >
                <span className="font-bold text-gray-900 pr-4 text-sm md:text-base">{item.q}</span>
                <i className={`ri-arrow-down-s-line text-xl text-teal-600 flex-shrink-0 transition-transform ${openIndex === i ? 'rotate-180' : ''}`}></i>
              </button>
              <div className={`px-6 pb-5 ${openIndex === i ? '' : 'hidden'}`}>
                <p className="text-gray-600 leading-relaxed text-sm md:text-base">{item.a}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}